module.exports = __webpack_public_path__ + "static/media/magic_rule_pressed_button.c81e2c8c.png";